<template>
  <div class="supportPopUp" v-if="support_visible">
    <div class="bg" @click="hideSupport"></div>
    <div class="body_pop_up">
      <div class="inner_wrapper">
        <div class="prewChoise" style="" @click="step == 0 ? hideSupport() : step--"></div>
        <div class="closePopUp" @click="hideSupport">
          <img src="../../assets/img/icons/menu_close.svg" alt="close">
        </div>
        <div class="requestStatus">
          <div class="theme">Тема</div>
          <div class="counter" v-show="step < 2">{{ step + 1 }} / 2</div>
          <div class="request">Обращение</div>
          <div class="statusBar"></div>
        </div>
        <div id="requestSelect" class="requestSelect" v-show="step == 0">
          <h5>Свяжитесь с нами</h5>
          <h4>Выберите тему для обращения</h4>
          <div class="requestType">
            <div class="requestItem selected" @click="setRequestType('Поддержка')">
              <div class="img"></div>
              <p>Поддержка</p>
            </div>
            <div class="requestItem" @click="setRequestType('Бизнес')">
              <div class="img" style="background-position: 99px 0;"></div>
              <p>Бизнес</p>
            </div>
            <div class="requestItem" @click="setRequestType('Карьера')">
              <div class="img" style="background-position: 152px 0;"></div>
              <p>Карьера</p>
            </div>
            <div class="requestItem" @click="setRequestType('Бизнес')">
              <div class="img" style="background-position: 48px 0;"></div>
              <p>Другое</p>
            </div>
            <div class="requestItem">
              <div class="img" style="background-position: 200px 0;"></div>
              <p>Возврат билетов</p>
            </div>
          </div>
        </div>
        <div id="requestQuestion" class="requestQuestion" v-show="step == 1">
          <h5>Свяжитесь с нами</h5>
          <h4>Обращение в поддержку</h4>
          <div class="requestInputs">
            <form action="">
              <fieldset>
                <input id="userEmail" type="email" autocomplete="off" required="" v-model="request.email">
                <label for="userEmail">Ваш E-mail</label>
              </fieldset>
              <fieldset>
                <textarea id="textArea" autocomplete="off" required="" v-model="request.message"></textarea>
                <label for="textArea">Введите сообщение</label>
              </fieldset>
              <input type="file" placeholder="+ прикрепить файл" name="+ прикрепить файл">
              <button type="submit" @click.prevent="step++">Отправить</button>
            </form>
          </div>
        </div>
        <div id="requestThx" class="requestThx" v-show="step == 2">
          <h5>Свяжитесь с нами</h5>
          <h4>Обращение в поддержку</h4>
          <div class="requestThxPage">
            <div class="img"></div>
            <p>Ваше обращение отправлено!</p>
            <!-- <a href="index.html">на Главную</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  data: function () {
    return {
      step: 0,
      request: {
        type: '',
        email: '',
        message: ''
      }
    }
  },
  computed: {
    support_visible: function () {
      return Store.state.support_visible
    }
  },
  methods: {
    setRequestType: function (type) {
      this.request.type = type
      this.step++
    },
    hideSupport: function () {
      this.step = 0
      this.request = {
        type: '',
        email: '',
        message: ''
      }
      Store.commit('hideSupport')
    }
  }
}
</script>




// WEBPACK FOOTER //
// support.vue?c2bb5bdc